import React, { useState } from "react";

interface Card {
  id: number;
  no: string;
  title: string;
  text: string;
}

const cardsData: Card[] = [
  {
    id: 1,
    title: "Crypto - Fiat Conversion",
    text: "Convert cryptocurrencies to Fiat currencies or Fiat currencies to the crypto of your preference in a fast and secure environment.",
    no: "01",
  },
  {
    id: 2,
    title: "OTC Desk Services",
    text: "We offer B2B/B2C VIP clients special conversion conditions depending on the size of the requested transaction giving you tailor made solutions.",
    no: "02",
  },
  {
    id: 3,
    title: "Liquidity Provider",
    text: "We specialise in liquidity provision, offering seamless integration via API for real-time pricing on fintech platforms. With us, you gain access to dynamic trade execution support, ensuring optimal transaction outcomes.",
    no: "03",
  },
];

const CardSlideshow: React.FC = () => {
  const [currentIndex, _setCurrentIndex] = useState(0);

  // Dimensiunea unui card (lățime + spațiu dintre carduri, de ex. 20rem + 2rem pentru spațiu)
  const cardWidth = 28; // Ajustează această valoare pentru dimensiunea reală

  // const handleNext = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex < cardsData.length - 1 ? prevIndex + 1 : 0
  //   );
  // };

  // const handlePrev = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex > 0 ? prevIndex - 1 : cardsData.length - 1
  //   );
  // };

  return (
    <div className="flex flex-col justify-start overflow-x-hidden">
      <div
        className="flex transition-transform duration-300"
        style={{
          transform: `translateX(-${currentIndex * cardWidth}rem)`, // Schimbăm poziția pe baza indexului
        }}
      >
        {cardsData.map((card, _index) => {
          // Aplica clase diferite pentru cardul curent
          // const isActive = index === currentIndex;
          return (
            <div
              key={card.id}
              className={`cardSlideShow w-[20rem] mx-[1rem] transition-colors duration-300 
                 bg-[#222B45] text-[#FFF] hover:bg-white hover:text-black
              `}
            >
              <div className="cardSlideShow__no">{card.no}</div>
              <div className="cardSlideShow__title">{card.title}</div>
              <div className="cardSlideShow__text">{card.text}</div>
            </div>
          );
        })}
      </div>
      <div className="w-full flex justify-end py-[3rem]">
        {/* <button onClick={handlePrev}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="25"
            viewBox="0 0 14 25"
            fill="none"
          >
            <path d="M12 24L2 12.283L12 1" stroke="white" stroke-width="3" />
          </svg>
        </button>
        <button onClick={handleNext}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="25"
            viewBox="0 0 14 25"
            fill="none"
          >
            <path d="M2 1L12 12.717L2 24" stroke="white" stroke-width="3" />
          </svg>
        </button> */}
      </div>
    </div>
  );
};

export default CardSlideshow;
